import { NgModule } from '@angular/core';

import { CachingDataSourceFactory } from './caching-data-source';

@NgModule({
  providers: [CachingDataSourceFactory]
})
export class DataSourceModule {
}
